import { NavLink } from 'react-router'
import { cn } from '@/helpers/utils'

interface TabProps {
	to: string
	label: string
	count?: number
	disabled?: boolean
}

const TAB_CLASS =
	'flex h-9 shrink-0 items-center gap-2 whitespace-nowrap border-b-2 px-1 pb-3 font-medium text-base'
const INACTIVE_CLASS = 'border-transparent text-neutral-500'

const TabCount = ({ count }: { count?: number }) =>
	count === undefined ? null : (
		<span className='rounded-full border border-neutral-200 bg-neutral-50 px-2.5 py-0.5 text-center font-medium text-neutral-700 text-sm'>
			{count}
		</span>
	)

const TabLink = ({ to, label, count, disabled }: TabProps) => {
	// A disabled tab is still worth showing — it tells the operator the stage
	// exists — so it keeps its place in the bar and only loses the navigation.
	if (disabled) {
		return (
			<span
				aria-disabled='true'
				className={cn(
					TAB_CLASS,
					INACTIVE_CLASS,
					'cursor-not-allowed opacity-35'
				)}
			>
				{label}
				<TabCount count={count} />
			</span>
		)
	}

	return (
		<NavLink
			className={({ isActive }) =>
				cn(
					TAB_CLASS,
					isActive
						? 'border-neutral-700 text-neutral-700'
						: cn(INACTIVE_CLASS, 'opacity-55')
				)
			}
			to={to}
		>
			{label}
			<TabCount count={count} />
		</NavLink>
	)
}

export { TabLink }
